import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Alert,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";

import { connect, useDispatch} from "react-redux";
import { withRouter, Link,} from "react-router-dom";
import { contactsUpdate } from "../../../store/contacts/actions";
import { getDataUser, postUserUpdate } from "../../../helpers/backend";
import { MetaTags } from "react-meta-tags";
import ButtonVolver from "../../../components/ButtonVolver";
import SignatureModal from "../../../components/SignatureModal";

// Estilos CSS personalizados
const customStyles = `
  .user-edit-container {
    background: #F1F8E9;
    min-height: 100vh;
    padding: 20px 0;
  }

  .bg-gradient-primary {
    background:#C8E6C9;
  }

  .avatar-circle {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
  }

  .section-header {
    display: flex;
    background: #F1F8E9
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .section-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }

  .form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #fff;
  }

  .form-control-modern:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
    background: #fff;
  }

  .form-control-readonly {
    background-color: #f8f9fa;
    border-color: #e9ecef;
    color: #6c757d;
  }

  .form-select.form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    background: #fff;
  }

  .btn-modern {
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
  }

  .btn-modern:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  .badge-soft {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.2);
  }

  .signature-preview-img {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .empty-state-icon {
    opacity: 0.6;
  }

  .card {
    border-radius: 15px;
    overflow: hidden;
  }

  .shadow-sm {
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08) !important;
  }

  .shadow-lg {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
  }

  .border-0 {
    border: none !important;
  }

  .action-buttons .btn {
    font-weight: 600;
  }

  .form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
  }

  .text-primary {
    color: #667eea !important;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-warning {
    color: #ffc107 !important;
  }

  .bg-primary {
    background-color: #667eea !important;
  }

  .bg-success {
    background-color: #28a745 !important;
  }

  .bg-warning {
    background-color: #ffc107 !important;
  }

  .phone-input-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .country-code-select {
    width: 80px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
    cursor: pointer;
  }
  .country-code-select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  .phone-input {
    flex: 1;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: white;
  }
  .phone-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  .phone-input::placeholder {
    color: #6c757d;
    opacity: 1;
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = customStyles;
  document.head.appendChild(styleElement);
}

const UserProfile = (props) => {
  const dispatch = useDispatch();
  const URL = process.env.REACT_APP_API_URL;
  const url = URL.split("/api");

  const [showAlert, setShowAlert] = useState(false);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureFile, setSignatureFile] = useState(null);
  const [existingSignature, setExistingSignature] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [isUpdatingFields, setIsUpdatingFields] = useState(false);

  const getData = async () => {
    const response = await getDataUser();
    console.log(response);
    
    const data = response.data[0];
    
    // Extraer teléfono del array phone si existe
    let telefono = '';
    let codigoPais = '+57';
    
    if (data.phone && data.phone.length > 0) {
      const phoneData = data.phone[0].telefono;
      // Extraer código de país (primeros 2-3 dígitos)
      if (phoneData.startsWith('57')) {
        codigoPais = '+57';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('1')) {
        codigoPais = '+1';
        telefono = phoneData.substring(1);
      } else if (phoneData.startsWith('52')) {
        codigoPais = '+52';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('34')) {
        codigoPais = '+34';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('54')) {
        codigoPais = '+54';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('56')) {
        codigoPais = '+56';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('51')) {
        codigoPais = '+51';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('58')) {
        codigoPais = '+58';
        telefono = phoneData.substring(2);
      } else if (phoneData.startsWith('593')) {
        codigoPais = '+593';
        telefono = phoneData.substring(3);
      } else if (phoneData.startsWith('591')) {
        codigoPais = '+591';
        telefono = phoneData.substring(3);
      } else {
        // Si no coincide con ningún código conocido, usar el número completo
        telefono = phoneData;
      }
      
      // Formatear el teléfono
      telefono = formatPhoneNumber(telefono);
    }
    
    setFormData({
      full_name: data.get_full_name,
      contactType: data.contactType || "PERSONA NATURAL",
      documentType: data.documentType,
      documentNumber: data.documentNumber,
      gender: data.gender,
      birthdate: data.birthdate,
      city: data.city,
      telefono: telefono,
      codigoPais: codigoPais,
      id: data.id,
      // Campos específicos (solo lectura)
      codigoCAUAGENT: (() => {
        // Si es un string JSON, parsearlo; si es array, devolverlo; si no, array vacío
        if (typeof data.codigoCAUAGENT === 'string' && data.codigoCAUAGENT.startsWith('[')) {
          try {
            return JSON.parse(data.codigoCAUAGENT);
          } catch {
            return data.codigoCAUAGENT ? [data.codigoCAUAGENT] : [];
          }
        }
        return Array.isArray(data.codigoCAUAGENT) ? data.codigoCAUAGENT : (data.codigoCAUAGENT ? [data.codigoCAUAGENT] : []);
      })(),
      codigo_visitador: data.codigo_visitador || "",
      cargo: data.cargo || "",
      firma: data.firma
    });

    // Cargar firma existente
    if (data.firma && data.firma !== "undefined") {
      setExistingSignature(data.firma);
    }

  };
     
  const [formData, setFormData] = useState({
    full_name: "",
    contactType: "",
    documentType: "",
    documentNumber: "",
    gender: "",
    birthdate: "",
    city: "",
    telefono: "",
    codigoPais: "+57",
    id: "",
    codigoCAUAGENT: "",
    codigo_visitador: "",
    cargo: "",
    firma: null
  });

  const {  
    full_name,  
    contactType,
    documentType,  
    documentNumber, 
    gender,
    birthdate, 
    city,
    telefono,
    codigoPais,
    id,
    codigoCAUAGENT,
    codigo_visitador,
    cargo
  } = formData;

  useEffect(() => {
    getData();
  }, []);
  

  const onChange = (e) => {
    setFormData({ ...formData, 
     [e.target.name]: e.target.value });
  };

  // Función para formatear el número de teléfono
  const formatPhoneNumber = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return numbers.slice(0, 3) + ' ' + numbers.slice(3);
    return numbers.slice(0, 3) + ' ' + numbers.slice(3, 6) + ' ' + numbers.slice(6, 10);
  };

  // Función para validar el número de teléfono
  const validatePhoneNumber = (phone, countryCode) => {
    if (!phone || phone.trim() === '') {
      return { isValid: false, message: 'El número de teléfono es obligatorio' };
    }
    
    const numbersOnly = phone.replace(/\s/g, '');
    const fullNumber = countryCode + numbersOnly;
    const totalNumbers = fullNumber.replace(/\D/g, '');
    
    if (totalNumbers.length < 10 || totalNumbers.length > 15) {
      return { isValid: false, message: 'Ingrese un número de teléfono válido (10-15 dígitos)' };
    }
    
    return { isValid: true, message: '', fullNumber: totalNumbers };
  };

  const handleSignatureSave = (signatureFile) => {
    setSignatureFile(signatureFile);
    setFormData({ ...formData, firma: signatureFile });
    setShowSignatureModal(false);
    toast.success("Firma guardada exitosamente");
  };

  const handleRemoveSignature = () => {
    setSignatureFile(null);
    setExistingSignature(null);
    setFormData({ ...formData, firma: null });
    toast.info("Firma eliminada");
  };

  const getSignatureUrl = (signaturePath) => {
    if (!signaturePath) return null;
    return `${url[0]}${signaturePath}`;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsUpdatingFields(true);

    try {
      // Validar y formatear teléfono si se proporciona
      let telefonoCompleto = '';
      if (telefono) {
        const phoneValidation = validatePhoneNumber(telefono, codigoPais);
        if (!phoneValidation.isValid) {
          toast.error(phoneValidation.message);
          setIsUpdatingFields(false);
          return;
        }
        // Combinar código de país con número (sin espacios)
        const numeroLimpio = telefono.replace(/\s/g, '');
        telefonoCompleto = codigoPais.replace('+', '') + numeroLimpio;
      }

      // Primera petición: Actualizar datos básicos del usuario
      const basicUserData = {
        full_name,
        contactType,
        documentType,
        documentNumber,
        gender,
        birthdate,
        city,
        telefono: telefonoCompleto,
      };

      await dispatch(contactsUpdate(id, basicUserData));
      toast.success('Información básica actualizada exitosamente');

      // Segunda petición: Actualizar campos específicos usando postUserUpdate
      // No enviamos user_id para auto-actualización (el servidor usa el usuario autenticado)
      const specificFieldsData = {
        contactType: contactType,
        codigo_visitador: codigo_visitador,
        cargo: cargo,
        codigoCAUAGENT: JSON.stringify(codigoCAUAGENT),
        telefono: telefonoCompleto
      };

      const formDataToSend = new FormData();
      Object.keys(specificFieldsData).forEach(key => {
        formDataToSend.append(key, specificFieldsData[key]);
      });
      
      // Solo agregar la firma si existe
      if (signatureFile) {
        console.log('Agregando archivo de firma');
        formDataToSend.append('firma', signatureFile);
      }
      
      await postUserUpdate(formDataToSend);
      toast.success('Campos específicos actualizados exitosamente');

      setUpdateSuccess(true);
      setShowAlert(true);
      
      setTimeout(() => {
        setUpdateSuccess(false);
        setShowAlert(false);
      }, 5000);

    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      toast.error('Error al actualizar el usuario: ' + (error.message || 'Error desconocido'));
    } finally {
      setIsUpdatingFields(false);
    }
  };
console.log(id);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ciudad Limpia | Perfil de Usuario</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Col className="d-flex gap-3 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Perfil de Usuario
            </span>
          </Col>

          <div className="row">
            <div className="col-lg-10 mx-auto">
              {/* Alertas de éxito y error */}
              {props.contactsUpdated.id && showAlert ? (
                <SweetAlert
                  title="¡Perfecto!"
                  success
                  timeout={2000}
                  showConfirm={false}
                  onConfirm={() => setShowAlert(false)}
                >
                  Usuario actualizado exitosamente
                </SweetAlert>
              ) : null}
              
              {updateSuccess && (
                <Alert color="success" className="mb-4">
                  <i className="mdi mdi-check-circle me-2"></i>
                  El perfil ha sido actualizado correctamente
                </Alert>
              )}

              <div className="user-edit-container">
                <Form onSubmit={onSubmit}>
                  <Row>
                    {/* Columna Principal */}
                    <Col lg={8}>
                      {/* Información Básica */}
                      <Card className="mb-4 border-0 shadow-sm">
                        <CardHeader className="border-bottom-0 pb-0">
                          <div className="section-header">
                            <div className="section-icon bg-primary">
                              <i className="mdi mdi-account text-white"></i>
                            </div>
                            <div>
                              <h5 className="mb-1 fw-bold">Información Personal</h5>
                              <p className="text-muted small mb-0">Datos básicos del usuario</p>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="pt-3">
                          <Row>
                            <Col md={12}>
                              <div className="mb-3">
                                <Label for="first_name" className="form-label fw-semibold">
                                  <i className="mdi mdi-account me-1 text-primary"></i>
                                  Nombres
                                </Label>
                                <Input
                                  type="text"
                                  name="first_name"
                                  id="first_name"
                                  placeholder="Nombres"
                                  value={full_name}
                                  onChange={onChange}
                                  className="form-control-modern"
                                  invalid={props.error.full_name ? true : false}
                                />
                                <FormFeedback>{props.error.full_name}</FormFeedback>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="documentType" className="form-label fw-semibold">
                                  <i className="mdi mdi-card-account-details me-1 text-primary"></i>
                                  Tipo de Documento
                                </Label>
                                <select
                                  className="form-select form-control-modern"
                                  id="documentType"
                                  name="documentType"
                                  value={documentType}
                                  onChange={onChange}
                                >
                                  <option value="CEDULA">Cédula Ciudadanía</option>
                                  <option value="PASAPORTE">Pasaporte</option>
                                  <option value="CEDULA_EXTRANJERIA">Cédula de Extranjería</option>
                                  <option value="Nit">NIT</option>
                                  <option value="OTRO">Otro</option>
                                </select>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="documentNumber" className="form-label fw-semibold">
                                  <i className="mdi mdi-identifier me-1 text-primary"></i>
                                  Número de Documento
                                </Label>
                                <Input
                                  type="text"
                                  name="documentNumber"
                                  id="documentNumber"
                                  placeholder="Número de documento"
                                  value={documentNumber}
                                  onChange={onChange}
                                  className="form-control-modern"
                                  invalid={props.error.documentNumber ? true : false}
                                />
                                <FormFeedback>{props.error.documentNumber}</FormFeedback>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="gender" className="form-label fw-semibold">
                                  <i className="mdi mdi-human-male-female me-1 text-primary"></i>
                                  Género
                                </Label>
                                <select
                                  className="form-select form-control-modern"
                                  id="gender"
                                  name="gender"
                                  value={gender}
                                  onChange={onChange}
                                >
                                  <option value="Masculino">Masculino</option>
                                  <option value="Femenino">Femenino</option>
                                  <option value="Otro">Otro</option>
                                </select>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="birthdate" className="form-label fw-semibold">
                                  <i className="mdi mdi-calendar me-1 text-primary"></i>
                                  Fecha de Nacimiento
                                </Label>
                                <Input
                                  type="date"
                                  name="birthdate"
                                  id="birthdate"
                                  value={birthdate}
                                  onChange={onChange}
                                  className="form-control-modern"
                                  invalid={props.error.birthdate ? true : false}
                                />
                                <FormFeedback>{props.error.birthdate}</FormFeedback>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label for="city" className="form-label fw-semibold">
                                  <i className="mdi mdi-map-marker me-1 text-primary"></i>
                                  Ciudad
                                </Label>
                                <Input
                                  type="text"
                                  name="city"
                                  id="city"
                                  placeholder="Ciudad"
                                  value={city}
                                  onChange={onChange}
                                  className="form-control-modern"
                                  invalid={props.error.city ? true : false}
                                />
                                <FormFeedback>{props.error.city}</FormFeedback>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-0">
                                <Label className="form-label fw-semibold">
                                  <i className="mdi mdi-phone me-1 text-primary"></i>
                                  Teléfono
                                </Label>
                                <div className="phone-input-container" style={{display: 'flex', border: '2px solid #e9ecef', borderRadius: '10px', overflow: 'hidden'}}>
                                  <select 
                                    name="codigoPais"
                                    value={codigoPais}
                                    onChange={onChange}
                                    style={{padding: '12px 8px', border: 'none', background: '#f8f9fa', borderRight: '1px solid #ced4da', outline: 'none', fontSize: '14px'}}
                                  >
                                    <option value="+57">🇨🇴 +57</option>
                                    <option value="+1">🇺🇸 +1</option>
                                    <option value="+52">🇲🇽 +52</option>
                                    <option value="+34">🇪🇸 +34</option>
                                    <option value="+54">🇦🇷 +54</option>
                                    <option value="+56">🇨🇱 +56</option>
                                    <option value="+51">🇵🇪 +51</option>
                                    <option value="+58">🇻🇪 +58</option>
                                    <option value="+593">🇪🇨 +593</option>
                                    <option value="+591">🇧🇴 +591</option>
                                  </select>
                                  <Input
                                    type="tel"
                                    name="telefono"
                                    id="telefono"
                                    placeholder="300 123 4567"
                                    value={telefono}
                                    onChange={(e) => {
                                      const formatted = formatPhoneNumber(e.target.value);
                                      setFormData({ ...formData, telefono: formatted });
                                    }}
                                    style={{flex: 1, padding: '12px 16px', border: 'none', outline: 'none', fontSize: '14px', borderRadius: '0'}}
                                    invalid={props.error.telefono ? true : false}
                                  />
                                </div>
                                <FormFeedback>{props.error.telefono}</FormFeedback>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      {/* Información Profesional (Solo Lectura) */}
                      <Card className="mb-4 border-0 shadow-sm">
                        <CardHeader className="border-bottom-0 pb-0">
                          <div className="section-header">
                            <div className="section-icon bg-success">
                              <i className="mdi mdi-briefcase text-white"></i>
                            </div>
                            <div>
                              <h5 className="mb-1 fw-bold">Información Profesional</h5>
                              <p className="text-muted small mb-0">Datos laborales y códigos (Solo lectura)</p>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="pt-3">
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label fw-semibold">
                                  <i className="mdi mdi-account-group me-1 text-success"></i>
                                  Tipo de Contacto
                                </Label>
                                <Input
                                  type="text"
                                  value={contactType}
                                  readOnly
                                  className="form-control-modern form-control-readonly"
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label fw-semibold">
                                  <i className="mdi mdi-badge-account me-1 text-success"></i>
                                  Cargo
                                </Label>
                                <Input
                                  type="text"
                                  value={cargo || "No asignado"}
                                  readOnly
                                  className="form-control-modern form-control-readonly"
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <div className="mb-3">
                                <Label className="form-label fw-semibold">
                                  <i className="mdi mdi-identifier me-1 text-success"></i>
                                  Código CAU AGENT
                                </Label>
                                <Input
                                  type="text"
                                  value={Array.isArray(codigoCAUAGENT) && codigoCAUAGENT.length > 0 ? codigoCAUAGENT.join(', ') : "No asignado"}
                                  readOnly
                                  className="form-control-modern form-control-readonly"
                                />
                                {Array.isArray(codigoCAUAGENT) && codigoCAUAGENT.length > 0 && (
                                  <small className="text-muted mt-1 d-block">
                                    Códigos seleccionados: {codigoCAUAGENT.length}
                                  </small>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-0">
                                <Label className="form-label fw-semibold">
                                  <i className="mdi mdi-card-account-details me-1 text-success"></i>
                                  Código Visitador
                                </Label>
                                <Input
                                  type="text"
                                  value={codigo_visitador || "No asignado"}
                                  readOnly
                                  className="form-control-modern form-control-readonly"
                                />
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Columna Lateral */}
                    <Col lg={4}>
                      {/* Firma Digital */}
                      <Card className="mb-4 border-0 shadow-sm">
                        <CardHeader className="border-bottom-0 pb-0">
                          <div className="section-header">
                            <div className="section-icon bg-warning">
                              <i className="mdi mdi-draw text-white"></i>
                            </div>
                            <div>
                              <h5 className="mb-1 fw-bold">Firma Digital</h5>
                              <p className="text-muted small mb-0">Gestión de firma</p>
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="pt-3">
                          {existingSignature && !signatureFile ? (
                            <div className="signature-preview-modern">
                              <div className="signature-image-container mb-3">
                                <img
                                  src={getSignatureUrl(existingSignature)}
                                  alt="Firma actual"
                                  className="signature-preview-img"
                                  style={{
                                    maxWidth: '100%',
                                    maxHeight: '120px',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '8px',
                                    backgroundColor: 'white',
                                    display: 'block',
                                    margin: '0 auto'
                                  }}
                                />
                              </div>
                              <div className="signature-actions">
                                <Button
                                  type="button"
                                  color="primary"
                                  size="sm"
                                  className="w-100 mb-2 btn-modern"
                                  onClick={() => setShowSignatureModal(true)}
                                >
                                  <i className="mdi mdi-pencil me-1"></i>
                                  Modificar Firma
                                </Button>
                                <Button
                                  type="button"
                                  color="danger"
                                  size="sm"
                                  outline
                                  className="w-100 btn-modern"
                                  onClick={handleRemoveSignature}
                                >
                                  <i className="mdi mdi-delete me-1"></i>
                                  Eliminar Firma
                                </Button>
                              </div>
                            </div>
                          ) : signatureFile ? (
                            <div className="mb-3">
                              <Alert color="info">
                                <i className="mdi mdi-information me-2"></i>
                                Nueva firma seleccionada. Guarda los cambios para aplicarla.
                                <div className="mt-2">
                                  <Button
                                    type="button"
                                    color="warning"
                                    size="sm"
                                    outline
                                    onClick={() => setSignatureFile(null)}
                                  >
                                    <i className="mdi mdi-close me-1"></i>
                                    Cancelar cambio
                                  </Button>
                                </div>
                              </Alert>
                            </div>
                          ) : (
                            <div className="signature-empty-modern text-center">
                              <div className="empty-state-icon mb-3">
                                <i className="mdi mdi-draw" style={{ fontSize: '3rem', color: '#6c757d' }}></i>
                              </div>
                              <h6 className="text-muted mb-2">Sin firma</h6>
                              <p className="text-muted small mb-3">
                                Agregue su firma digital
                              </p>
                              <Button
                                type="button"
                                color="warning"
                                className="w-100 btn-modern"
                                onClick={() => setShowSignatureModal(true)}
                              >
                                <i className="mdi mdi-plus me-1"></i>
                                Agregar Firma
                              </Button>
                            </div>
                          )}
                        </CardBody>
                      </Card>

                      {/* Acciones */}
                      <Card className="border-0 shadow-sm">
                        <CardBody>
                          <div className="action-buttons">
                            <Button
                              type="submit"
                              color="primary"
                              disabled={isUpdatingFields}
                              className="w-100 mb-2 btn-modern btn-lg"
                            >
                              {isUpdatingFields ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                  Actualizando...
                                </>
                              ) : (
                                <>
                                  <i className="mdi mdi-content-save me-1"></i>
                                  Guardar Cambios
                                </>
                              )}
                            </Button>
                            <Link to="/dashboard" className="btn btn-light w-100 btn-modern">
                              <i className="mdi mdi-arrow-left me-1"></i>
                              Volver
                            </Link>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Modal de Firma Digital */}
      <SignatureModal
        isOpen={showSignatureModal}
        onClose={() => setShowSignatureModal(false)}
        onSave={handleSignatureSave}
        title="Gestión de Firma Digital"
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, contacts, contactsUpdated } = state.Contacts;
  return { error, loading, contacts, contactsUpdated };
};
contactsUpdate.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsUpdated: PropTypes.object,
};
export default withRouter(connect(mapStateToProps,{ contactsUpdate })(UserProfile));